import React from 'react';
import { useTranslation } from 'react-i18next';
import routes from '../../../router/routes';
import useQueryString from '../../../hooks/useQueryString';
import DictionaryList from '../../../containers/shared/DictionaryList';
import { useGetAgeCategoriesQuery } from '../../../store/apis/dictionaries/age-categories';

const List = () => {
  const [t] = useTranslation();
  const { page = 1, pageSize = 20 } = useQueryString();
  const { data, isLoading, isFetching } = useGetAgeCategoriesQuery({ page, pageSize });

  return (
    <DictionaryList
      title={t('Категории возрастов')}
      data={data?.results}
      dataCount={data?.count}
      loading={isLoading || isFetching}
      detailRoute={routes.ageCategories}
    />
  );
};

export default List;
